import { createFileRoute } from "@tanstack/react-router";
import { ApiAccessPage } from "@/pages/api-access";

export const Route = createFileRoute(
  "/_authed/$companySlug/_settings/settings/api",
)({
  component: ApiAccessPage,
});
